import React from "react"
import styles from "./styles.scss"
import posed from "react-pose"
import { Link } from "react-router-dom"

const CaseStudies = posed.aside({
  enter: { scale: 1, delayChildren: 400, staggerChildren: 100, delay: 200 },
  exit: { scale: 0 },
})

const PosedLink = posed.div({
  enter: { x: 0, opacity: 1 },
  exit: { x: 100, opacity: 0 },
})

class CaseStudyLink extends React.PureComponent {
  handleHover = () => this.props.onHover(this.props.id)

  render() {
    const { name, project, url } = this.props

    return (
      <PosedLink className={styles.container} onMouseEnter={this.handleHover}>
        <Link to={url}>
          <div className={styles.caseStudyLinkTitle}>{name}</div>
          <div className={styles.caseStudyLinkProject}>{project}</div>
        </Link>
      </PosedLink>
    )
  }
}

const CaseStudyLinks = ({ onHover, caseStudies }) => (
  <CaseStudies className={styles.caseStudies} initialPose="exit" pose="enter">
    <h2 className={styles.title}>
      Se hur SAITS
      <br />
      hjälpte dessa företag
    </h2>
    {caseStudies.map(caseStudy => (
      <CaseStudyLink
        key={caseStudy.id}
        id={caseStudy.id}
        name={caseStudy.landingPageHeroTitle}
        project={caseStudy.company}
        onHover={onHover}
        url={caseStudy.path}
      />
    ))}
  </CaseStudies>
)

export default CaseStudyLinks



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Hero/CaseStudyLinks/index.jsx